import React, { Fragment } from 'react';

import EpisodesListItem from './EpisodesListItem';

import { IPodcastEpisode } from '@wix/podcasts-common/dist/podcast';

interface IEpisodesListProps {
  episodes: IPodcastEpisode[];
  podcastImage: string;
  searchMode: boolean;
}

function EpisodesList({
  episodes,
  podcastImage,
  searchMode,
}: IEpisodesListProps) {
  return (
    <Fragment>
      {episodes.map((episode, index) => (
        <EpisodesListItem
          key={episode.id}
          podcastImage={podcastImage}
          episode={episode}
          isFirst={index === 0}
          isLatest={index === 0 && !searchMode}
        />
      ))}
    </Fragment>
  );
}

export default EpisodesList;
